import {PROSCACHE, CONSCACHE} from '../../../shared/library/cards/pros-cons';
import {alternativesSlugs, consSlugs, decisionSlugs} from './../utils';

export const toolConditions = [
  {
    name: 'showLoggedOutIntegrationsCta',
    condition: ({currentUser, stackup, tool, toolsLoaded}) =>
      !currentUser &&
      stackup &&
      toolsLoaded &&
      tool &&
      tool.cachedAllToolIntegrations &&
      tool.cachedAllToolIntegrations.edges.length > 4
  },
  {
    name: 'showPrivateStacksComparision',
    condition: ({tool}) =>
      tool && tool.privateStacksList && tool.privateStacksList.edges.length !== 0
  },
  {
    name: 'showTeamComparision',
    condition: ({tool}) => tool && tool.teams && tool.teams.edges.length !== 0
  },
  {
    name: 'showPros',
    condition: ({tool}) => tool && tool[PROSCACHE] && tool[PROSCACHE].edges.length !== 0
  },
  {
    name: 'showCons',
    condition: ({tool}) => tool && tool[CONSCACHE] && tool[CONSCACHE].edges.length !== 0
  },
  {
    name: 'showCompanyUsing',
    condition: ({tool}) =>
      tool && tool.cachedCompanyStacksUsing && tool.cachedCompanyStacksUsing.edges.length !== 0
  },
  {
    name: 'showOfficialArticles',
    condition: ({tool}) => tool && tool.officialArticles && tool.officialArticles.edges.length !== 0
  },
  {
    name: 'showGithubRepos',
    condition: ({tool}) =>
      tool &&
      ((tool.githubStarsCount && tool.githubStarsCount !== 0) ||
        (tool.githubForksCount && tool.githubForksCount !== 0))
  },
  {
    name: 'showIntegrations',
    condition: ({tool}) =>
      tool && tool.cachedAllToolIntegrations && tool.cachedAllToolIntegrations.edges.length !== 0
  },
  {
    name: 'showVulnerabilities',
    condition: ({tool}) => tool && tool.vulnerabilities && tool.vulnerabilities.edges.length > 0
  },
  {
    name: 'showReleaseInfo',
    condition: ({tool}) => tool && tool.latestVersionNumber && tool.license
  },
  {
    name: 'showStats',
    condition: ({tool}) =>
      tool && tool.dependentPackagesCount !== null && tool.membersCount !== null
  }
];

export const conditions = [
  {name: 'stackupPath', condition: ({stackup}) => (stackup ? stackup.path : null)},
  {
    name: 'contactEnabledTools',
    condition: ({stackup}) =>
      stackup && stackup.contactEnabledTools ? stackup.contactEnabledTools : null
  },
  {
    name: 'showJobs',
    condition: ({stackup, privateMode}) => !privateMode && stackup && stackup.jobs.count !== 0
  },
  {
    name: 'showPosts',
    condition: ({stackup}) => stackup && stackup.featuredPosts && stackup.featuredPosts.count !== 0
  },
  {
    name: 'showDecisions',
    condition: ({stackup}) =>
      stackup &&
      (stackup.cachedStackDecisions.count !== 0 ||
        stackup.cachedStackDecisionsGetAdvice.count !== 0)
  },
  {name: 'jobsCount', condition: ({stackup}) => stackup && stackup.jobs.count},
  {
    name: 'showAlternativeTools',
    condition: ({stackup}) =>
      stackup && stackup.cachedAlternativeTools && stackup.cachedAlternativeTools.count !== 0
  },
  {
    name: 'removeAfterAlternatives',
    condition: ({slug}) => !alternativesSlugs.some(item => item === slug)
  },
  {
    name: 'removeAfterCons',
    condition: ({slug}) => !consSlugs.some(item => item === slug)
  },
  {
    name: 'showLoggedOutCta',
    condition: ({currentUser, stackup, toolsLoaded}) => !currentUser && stackup && toolsLoaded
  },
  {
    name: 'showTopContent',
    condition: ({stackup}) => stackup && stackup.topContent && stackup.topContent !== ''
  },
  {
    name: 'showBottomContent',
    condition: ({stackup}) => stackup && stackup.bottomContent && stackup.bottomContent !== ''
  },
  {
    name: 'removeAfterDecisions',
    condition: ({currentUser, slug, privateMode}) =>
      currentUser || privateMode || !decisionSlugs.some(item => item === slug)
  },
  {
    name: 'stackupForPackages',
    condition: ({stackup}) => stackup && stackup.packageStackup && stackup.packageStackup === true
  }
];
